// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */
/* eslint-disable camelcase */
// webgen:keep
import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type AutocompleteMatchedSubstring,
  type AutocompleteMatchedSubstringWireFormat,
  NewAutocompleteMatchedSubstring,
} from '../AutocompleteMatchedSubstring/AutocompleteMatchedSubstring';
import {
  type AutocompleteStructuredFormatting,
  type AutocompleteStructuredFormattingWireFormat,
  NewAutocompleteStructuredFormatting,
} from '../AutocompleteStructuredFormatting/AutocompleteStructuredFormatting';
import {
  type AutocompleteTermOffset,
  type AutocompleteTermOffsetWireFormat,
  NewAutocompleteTermOffset,
} from '../AutocompleteTermOffset/AutocompleteTermOffset';

export class AutocompletePrediction {
  readonly description?: string;
  readonly distance_meters?: number;
  readonly place_id?: string;
  readonly types?: string[];
  readonly matched_substrings?: AutocompleteMatchedSubstring[];
  readonly terms?: AutocompleteTermOffset[];
  readonly structured_formatting?: AutocompleteStructuredFormatting;

  constructor(data: { [key: string]: any } = {}) {
    this.description = data.description;
    this.distance_meters = data.distance_meters;
    this.place_id = data.place_id;
    this.types = data.types ?? [];
    this.matched_substrings = (data.matched_substrings ?? []).map((matched_substrings: any) =>
      NewAutocompleteMatchedSubstring(matched_substrings),
    );
    this.terms = (data.terms ?? []).map((terms: any) => NewAutocompleteTermOffset(terms));
    this.structured_formatting = NewAutocompleteStructuredFormatting(data.structured_formatting);
  }

  static zero(): AutocompletePrediction {
    const zeroValues: ExcludeMethodsDeep<AutocompletePrediction> = {};
    return new AutocompletePrediction(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AutocompletePredictionWireFormat = {
  description?: string;
  distance_meters?: number;
  place_id?: string;
  types?: string[];
  matched_substrings?: AutocompleteMatchedSubstringWireFormat[];
  terms?: AutocompleteTermOffsetWireFormat[];
  structured_formatting?: AutocompleteStructuredFormattingWireFormat;
};

type NewAutocompletePredictionProps = PartialDeep<
  AutocompletePrediction,
  { recurseIntoArrays: true }
>;
export const NewAutocompletePrediction: (
  props: NewAutocompletePredictionProps,
) => AutocompletePrediction = (props) => new AutocompletePrediction(props);

type NewAutocompletePredictionFromWireFormatProps = PartialDeep<
  AutocompletePredictionWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAutocompletePredictionFromWireFormat: (
  props: NewAutocompletePredictionFromWireFormatProps,
) => AutocompletePrediction = (props) => new AutocompletePrediction(props);
